import {
  FETCH_ENDPOINT_ACCESS,
  FETCH_SALES_OPENING_START_TIME,
  FETCH_USER, FETCH_USER_BACKUPS,
  FETCH_USER_INVOICES,
  FETCH_USER_MACHINES,
} from '../actions/types';
import { ADD_FORMATTED_SALES_START_TIME } from '../utils/user-utils';

export default function userReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_USER:
      return { ...state, profile: action.payload };
    case FETCH_USER_MACHINES:
      return { ...state, machines: action.payload, userDataLoaded: !!state.profile };
    case FETCH_USER_INVOICES:
      return { ...state, invoices: action.payload };
    case FETCH_USER_BACKUPS:
      return { ...state, backups: action.payload };
    case FETCH_ENDPOINT_ACCESS:
      return { ...state, endpointAccess: action.payload };
    case FETCH_SALES_OPENING_START_TIME:
      return { ...state, salesStartTime: ADD_FORMATTED_SALES_START_TIME(action.payload) };
    default:
      return state;
  }
}